import { Component, ViewChild, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Router, ActivatedRoute } from '@angular/router';
import { CalendarOptions } from '@fullcalendar/angular';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { DashboardService } from 'src/app/services/dashboard/dashboard.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  public userDetails: any;
  total_student:any;
  total_classroom:any;
  total_faculty:any;
  total_school:any;
  reporting_member:any=[];
  Events: any[] = [];
  progress:any=[];
  school:any=[];

  constructor(
    private breakpointObserver: BreakpointObserver,
    public dashboard : DashboardService,
    public router          : Router,
    private http           : HttpClient,
    public validator       : MatSnackBar,
    private route          : ActivatedRoute,
    private spinnerService : NgxSpinnerService
  ) { }

  ngOnInit(): void {
    let currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    this.userDetails = currentUser;
    this.getDashboardDetails();
  }

  getDashboardDetails() {
    var filterData = {
      'email'     : this.userDetails.userDetails.email,
      'role'      : this.userDetails.userDetails.role_id,
      'member_id' : this.userDetails.userDetails.member_id
    };
    //console.log(filterData)
    this.spinnerService.show();
    this.dashboard.getDashboardDetails(filterData).subscribe((res: any) =>{
      console.log(res);
      if (res.status) {
        this.total_student   = res.data.students;
        this.total_classroom   = res.data.batches;
        this.total_faculty   = res.data.associates;
        this.total_school   = res.data.schools;
        this.reporting_member   = res.data.reporting[0];
        this.progress= res.data.datas;
        this.school=res.data.school_details;
        this.spinnerService.hide();
      }
    },
    error=>{
    });
  }

}
